import { Mediator, app, ojs, payload } from "modular-openscriptjs";
import { eParse, approved, inform, processStart, processEnd } from "../helpers";
import { STRINGS, routes, uc, dc, api } from "../declarations";
import { tool } from "../fotastart";
import { $e } from "../ojs.events";

const h = app("h");
const ac = app("ac");

export default class OrderMediator extends Mediator {
	$$order = {
		needs: {
			payment: (ed, event) => {
				this.getPayment(ed, event);
			},
			catalog: (ed, event) => {
				this.listOrders(ed, event);
			},
			businessOrders: (ed, event) => {
				this.getBusinessOrders(ed, event);
			},
			markAsReady: (ed, event) => {
				this.markAsReady(ed, event);
			},
			markAsProcessing: (ed, event) => {
				this.markAsProcessing(ed, event);
			},
			statusChange: (ed, event) => {
				this.moveOrder(ed, event);
			},
			massStatusChange: (ed, event) => {
				this.moveMany(ed, event);
			},
			completionCode: (ed, event) => {
				this.sendCode(ed, event);
			},
			surplusComputation: (ed, event) => {
				this.computeSurplus(ed, event);
			},
			refresh: (ed, event) => {
				this.updateOrderInList(ed, event);
			},
		},

		
	};

	$paymentRequest = {
		deleted: (ed, event) => {
			if (ac.activeOrder.value) {
				this.send(
					$e.order.needs.refresh,
					payload({ orderId: ac.activeOrder.id })
				);
			}
		},
	};

	$$deliverer = {
		has: {
			arrived: (ed, event) => {
				this.informCustomer(ed, event);
			},
		},
		needs: {
			orderStatus: (ed, event) => {
				this.getOrderStatus(ed, event);
			},
			allDeliverers: (ed, event) => {
				this.getAllDeliverers();
			},
			to: {
				transferOrder: (ed, event) => {
					this.transferOrder(ed, event);
				},
			},
		},
	};

	$$user = {
		loggedOut: (ed, event) => {
			this.send($e.system.needs.reload);
		},
	};

	$$purchase = {
		is: {
			confirming: (ed, event) => this.resetTracking(),
		},
	};

	$$ui = {
		needs: {
			actionsForm: (ed, event) => {
				console.log("ui:needs:actionsForm fired!!!", ac.actions.value);

				if (ac.actions.value === "order-filter-actions") {
					if (this.actionsFormHolder) {
						this.actionsFormHolder.dispose();
						// return;
					}

					this.actionsFormHolder = tool.offcanvas(
						h.OrderFilters(),
						h.span(
							{
								class: "text-secondary d-block text-center",
								onclick: () => this.actionsFormHolder.hide(),
							},
							h.i({ class: "fa-solid fa-chevron-down" })
						),
						"bottom",
						{
							data_bs_backdrop: true,
							data_bs_scroll: true,
							style: "min-height: auto; max-height: fit-content; max-width: 500px; margin-left: auto; margin-right: auto; z-index:1080;",
							class: "shadow-lg",
						}
					);

					setTimeout(() => this.actionsFormHolder.show(), 100);
				}
			}
		},
		not: {
			need: {
				actionsForm: (ed, event) => {
					this.actionsFormHolder?.hide();
				}
			}
		}
	};

	$$echo = {
		OrderStatusChanged_OrderUpdated: async (ed, event) => {
			let data = eParse(ed).message.get("data");
			let orderId = data.id;

			if (!orderId) return;

			let res = await api.get(`${routes.orders}/${orderId}`);

			if (!res) {
				return;
			}

			let order = res.data.order;

			for (let i in ac.orders.value) {
				if (ac.orders[i].id == orderId) {
					ac.orders[i] = order;
				}
			}

			if (ac.activeOrder.value?.id == orderId) {
				ac.activeOrder.value = order;
			}
		},
	};

	async sendCode(ed, event) {
		let data = eParse(ed);
		let res = await api.post(
			`riders/${routes.orders}/${data.message.get(
				"orderId",
				0
			)}/completion-code`
		);

		if (!res) {
			return;
		}

		inform(res.message, STRINGS.SUCCESS);
	}

	async computeSurplus(ed, event) {
		let data = eParse(ed);
		let res = await api.post(
			`riders/${routes.orders}/${data.message.get(
				"orderId",
				0
			)}/compute-surplus`
		);

		if (!res) {
			return;
		}

		inform(res.message, STRINGS.SUCCESS);
		this.send(
			$e.order.needs.refresh,
			payload({ orderId: data.message.get("orderId") })
		);
	}

	async informCustomer(ed, event) {
		let data = eParse(ed);

		let res = await api.get(
			`riders/orders/${data.message.orderId}/deliverer-arrived`,
			{},
			{ silent: true }
		);

		if (!res) {
			return;
		}

		inform(res.message, STRINGS.SUCCESS);
	}

	async getPayment(ed, event) {
		let data = eParse(ed);

		if (data.message.get("orderId", 0) == 0) {
			inform("Invalid order ID", STRINGS.ERROR);

			return;
		}

		let orderId = data.message.get("orderId");

		data.meta.put("route", `${routes.orders}/${orderId}/pay`);
		data.meta.put("editable", true);
		data.meta.put("type", "order");
		data.meta.put("typeId", orderId);
		data.meta.put("initiator", data.message.get("initiator", "customer"));

		this.broadcast(
			$e.payment.needs.collection,
			payload(data.message, data.meta)
		);
	}

	async getAllDeliverers() {
		api.get("/deliverers/all", {}, { silent: true }).then((res) => {
			let deliverers = res.data.deliverers;

			uc.deliverers = deliverers;
		});
	}

	async transferOrder(ed, event) {
		if (
			!approved(event, ed, "Are you sure you want to transfer this order")
		)
			return;

		let data = eParse(ed).message;

		let res = await api.post(
			`riders/orders/${data.order}/transfer/${data.fulfilmentUnit}`,
			{
				data,
			}
		);

		if (!res) {
			return;
		}

		inform(res.message, STRINGS.SUCCESS);

		return this.send(
			$e.order.is.transferred,
			payload({
				orderId: data.order,
			})
		);
	}

	async listOrders(ed, event) {
		let data = eParse(ed);

		const filter = data.message.get("filter", { statuses: ["confirmed"] });

		api.get(`riders/${routes.orders}`, {
			filter: JSON.stringify(filter),
			page: data.message.get("page", 1),
			interval: 5,
		})
			.then((content) => {
				ac.orders.value = content.data.orders.data;
			})
			.catch((e) => this.setCatalog());
	}

	setCatalog(catalog = []) {
		ac.orders.value = catalog;
		dc.selectedOrders.value = {};
		this.resetTracking();
	}

	resetTracking() {
		dc.selectedItems.value = {};
		dc.orderItemsMapping.value = {};
		dc.purchasePrices.value = {};
	}

	async moveOrder(ed, event) {
		let data = eParse(ed);

		processStart({ title: "Moving Order" });
		await this.moveSingleOrder(
			data.message.get("url"),
			data.message.get("orderId")
		);
		processEnd();

		this.broadcast(
			$e.order.statusChanged,
			payload({ orderId: data.message.get("orderId") })
		);
	}

	async moveSingleOrder(url, orderId, withMessage = true) {
		let secret_code = dc.orderCodes.value[orderId] ?? null;

		let res = await api.put(url, { secret_code });

		if (!res) {
			return this.broadcast($e.order.has.statusChangeError);
		}

		if (withMessage) inform("Order moved", STRINGS.SUCCESS);

		delete dc.orderCodes.value[orderId];

		for (let i in ac.orders.value) {
			if (ac.orders[i].id == orderId) {
				delete ac.orders[i];
				break;
			}
		}
	}

	async moveMany(ed, event) {
		let data = eParse(ed);
		const direction = data.message.get("direction");

		processStart({ title: "Moving orders" });

		for (let order of ac.orders.value) {
			if (order?.id in dc.selectedOrders.value) {
				delete dc.selectedOrders[order.id];

				let info = {};
				if (direction === "next") {
					info = order.next_status;
				} else if (direction === "previous") {
					info = order.previous_status;
				}

				if (Object.keys(info).length != 0) {
					await this.moveSingleOrder(info.url, order.id, false);
				}
			}
		}
		processEnd();

		inform("Order movement Completed", STRINGS.SUCCESS);
	}

	async updateOrderInList(ed, event) {
		const { orderId } = eParse(ed)?.message ?? {};

		let res = await api.get(`${routes.orders}/${orderId}`);

		if (!res) {
			return;
		}

		let order = res.data.order;

		for (let i in ac.orders.value) {
			if (ac.orders[i].id == orderId) {
				ac.orders[i] = order;
			}
		}

		if (ac.activeOrder.value?.id == orderId) {
			ac.activeOrder.value = order;
		}
	}

	async getBusinessOrders(ed, event) {
		const { message } = eParse(ed);
		
		const companyId = message.get("companyId");
		const filters = message.get("filters", {});

		let res = await api.get(routes.companyOrders(companyId), {
			...filters,
			page: message.get("page", 1),
			interval: message.get("interval", 15),
		});

		if (!res) return;

		this.broadcast($e.order.has.businessOrders, payload(res.data));
	}

	async markAsReady(ed, event) {
		const { message } = eParse(ed);
		const companyId = message.get("companyId");
		const orderId = message.get("orderId");
		const branchId = message.get("branchId");

		processStart({ title: "Updating order items" });

		let res = await api.put(routes.markOrderAsReady(companyId, orderId), {
			branch_id: branchId,
			organization: {
				id: companyId,
				type: "Company",
			}
		});

		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
		this.broadcast($e.order.has.updatedStatus, ed);
	}

	async markAsProcessing(ed, event) {
		const { message } = eParse(ed);
		const companyId = message.get("companyId");
		const orderId = message.get("orderId");
		const branchId = message.get("branchId");

		processStart({ title: "Updating order items" });

		let res = await api.put(routes.markOrderAsProcessing(companyId, orderId), {
			branch_id: branchId,
			organization: {
				id: companyId,
				type: "Company",
			}
		});

		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
		this.broadcast($e.order.has.updatedStatus, ed);
	}
}

